import store from './store';
import router from './router';
import i18n from './locales';

export default {
    methods: {
        onAndroidLogout() {
            let json = {
                'isSucceed': null
            };

            try {
                store.commit('user/LOGOUT');
                router.push('/login');

                json['isSucceed'] = true;
            } catch (error) {
                json['isSucceed'] = false;
            }

            //console.log(json);
            return JSON.stringify(json);
        },
        getAndroidLanguege() {
            let json = {
                'isSucceed': null,
                'data':null
            };


            try {
                let locale = i18n.global.locale.value;

                json['isSucceed'] = true;
                json['data'] = {
                    'locale': locale
                };
            } catch (error) {
                json['isSucceed'] = false;
            }

            //console.log(json);
            return JSON.stringify(json);
        },
        setAndroidLanguege(lang) {
            let langs = [
                'cn',
                'en',
                'jp',
                'ko',
                'tw'
            ];
            let json = {
                'isSucceed': null
            };

            try {
                if (langs.indexOf(lang)===-1) {
                    json['isSucceed'] = false;
                } else {
                    i18n.global.locale.value = lang;

                    json['isSucceed'] = true;
                }
            } catch (error) {
                json['isSucceed'] = false;
            }

            //console.log(json);
            return JSON.stringify(json);
        }
    }
};